module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_materials-cdf5e1fdff37c7e372f22ad6a0a4b5d7.svg";